import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake.js';

const OperationDiaryPDF = async (obj) => {
    pdfMake.fonts = {
        OpenSans: {
            normal: 'OpenSans-Regular.ttf',
            bold: 'OpenSans-Bold.ttf',
            italics: 'OpenSans-Italic.ttf',
            bolditalics: 'OpenSans-ExtraBoldItalic.ttf'
        },
        Merriweather: {
            normal: 'Merriweather-Regular.ttf',
            bold: 'Merriweather-Bold.ttf',
            italics: 'Merriweather-Italic.ttf',
            bolditalics: 'Merriweather-ExtraBoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Bold.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-BoldItalic.ttf'
        }
    };

    const listTipos = JSON.parse(sessionStorage.getItem('centroTipos'));

    let itemBodyFontSize = 7.5;
    //1.Documento 2.Hora 3.Nombre y Apellido 4.Entidad 5.Celular 6.Edad, 7.Examen, 8.Diagnostico 9.Peso 10.Talla 11.observacion
    let itemBody = [
        [
            {
                text: "Hora",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Nombre y Apellido",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Entidad",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Celular",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Servicio",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            }
        ],
    ];

    let itemArr = ["", "", "", "", ""];

    let itemWidths = ["auto", "auto", "auto", 'auto', "*"];
    //Si es medicina nuclear muestra el Peso y Talla
    if (listTipos.includes('3')) {
        itemBody[0].unshift({
            text: "Documento",
            style: "tableHeader",
            alignment: "center",
            fontSize: itemBodyFontSize
        });
        itemArr.push("");
        itemWidths.push('auto');

        itemBody[0].push({
            text: "Edad",
            style: "tableHeader",
            alignment: "center",
            fontSize: itemBodyFontSize
        });
        itemArr.push("");
        itemWidths.push('auto');

        itemBody[0].push({
            text: "Peso (Kg)",
            style: "tableHeader",
            alignment: "center",
            fontSize: itemBodyFontSize
        });
        itemArr.push("");
        itemWidths.push('auto');

        itemBody[0].push({
            text: "Talla (CM)",
            style: "tableHeader",
            alignment: "center",
            fontSize: itemBodyFontSize
        });
        itemArr.push("");
        itemWidths.push('auto');

        itemBody[0].push({
            text: "Observacion",
            style: "tableHeader",
            alignment: "center",
            fontSize: itemBodyFontSize
        });
        itemArr.push("");
        itemWidths.push('auto');
    } else if (listTipos.includes('1')) {
        itemBody[0].unshift({
            text: "Documento",
            style: "tableHeader",
            alignment: "center",
            fontSize: itemBodyFontSize
        });
        itemArr.push("");
        itemWidths.push('auto');
        itemBody[0].push({
            text: "Observacion",
            style: "tableHeader",
            alignment: "center",
            fontSize: itemBodyFontSize
        });
        itemArr.push("");
        itemWidths.push('auto');
    } else {
        itemBody[0].push({
            text: "Observacion",
            style: "tableHeader",
            alignment: "center",
            fontSize: itemBodyFontSize
        });
        itemArr.push("");
        itemWidths.push("auto");
    }

    const verifyAbreviattures = (abreviaturaConcatenada, servicios) => {
        let clinica = JSON.parse(sessionStorage.getItem('clinica'));
        if (!clinica.abreviatura_pdf_agenda) {
            return servicios[0].nombre;
        }
        else {
            return abreviaturaConcatenada;
        }
    }

    if (obj.items.length === 0) itemBody.push(itemArr);
    for (let index = 0; index < obj.items.length; index++) {
        const element = obj.items[index];
        let edadString = "";
        switch (element.unidad_medida_edad) {
            case 1: //Años
                edadString = element.edad.toString() + "A";
                break;
            case 2: //Meses
                edadString = element.edad.toString() + "M";
                break;
            case 3: //Dias
                edadString = element.edad.toString() + "D";
                break;
        }

        //1.Documento 2.Hora 3.Nombre y Apellido 4.Entidad 5.Celular 6.Edad, 7.Examen, 8.Diagnostico 9.Peso 10.Talla 11.observacion
        if (listTipos.includes('3')) //Medicina Nuclear
        {
            itemBody.push([
                { text: element.tip_documento + "-" + element.num_documento, alignment: "left" },
                { text: element.hora, alignment: "center" },
                { text: element.nombre_paciente, alignment: "left" },
                { text: element.nombre_entidad, alignment: "left" },
                { text: element.celular_paciente, alignment: "center" },
                { text: verifyAbreviattures(element.abreviatura_concatenada, element.servicio.servicios), alignment: "center" },
                { text: edadString, alignment: "center" },
                /* { text: element.diagnostico, alignment: "center" }, */
                { text: element.peso, alignment: "center" },
                { text: element.talla, alignment: "center" },
                { text: "", alignment: "center" }
            ]);
        } else if(listTipos.includes('1')){
            itemBody.push([
                { text: element.tip_documento + "-" + element.num_documento, alignment: "left" },
                { text: element.hora, alignment: "center" },
                { text: element.nombre_paciente, alignment: "center" },
                { text: element.nombre_entidad, alignment: "center" },
                { text: element.celular_paciente, alignment: "center" },
                { text: verifyAbreviattures(element.abreviatura_concatenada, element.servicio.servicios), alignment: "center" },
                { text: "", alignment: "center" }
            ]);
        } else {
            itemBody.push([
                { text: element.hora, alignment: "center" },
                { text: element.nombre_paciente, alignment: "center" },
                { text: element.nombre_entidad, alignment: "center" },
                { text: element.celular_paciente, alignment: "center" },
                { text: verifyAbreviattures(element.abreviatura_concatenada, element.servicio.servicios), alignment: "center" },
                { text: "", alignment: "center" }
            ]);
        }
    }

    pdfMake.tableLayouts = {
        exampleLayout: {
            hLineWidth: function (i, node) {
                if (i === 0 || i === node.table.body.length) {
                    return 1;
                }
                return i === node.table.headerRows ? 2 : 1;
            },
            vLineWidth: function (i) {
                return 1;
            },
            hLineColor: function (i, node) {
                if (i === 0 || i === node.table.body.length) {
                    return "black";
                }
                return i === 1 ? "black" : "#aaa";
            },
            fillColor: function (i, node) {
                return i === 0 ? "white" : i % 2 === 0 ? "#e8e8e8" : null;
            },
            paddingLeft: function (i) {
                return i === 0 ? 8 : 8;
            },
            paddingRight: function (i, node) {
                //return i === node.table.widths.length - 1 ? 0 : 8;
                return 3;
            },
            paddingTop: function (i, node) {
                return 3;
            },
            paddingBottom: function (i, node) {
                return 3;
            },

        },
    };

    var docDefinition = {
        pageSize: "LETTER",
        //pageOrientation: listTipos.includes('3') ? "portrait" : "landscape",
        pageOrientation: "landscape",
        info: {
            title: obj.title,
            author: "",
        },
        /*footer: function (currentPage, pageCount, pageSize) {
            return [
                {
                    canvas: [
                        {
                            type: "rect",
                            x: 0,
                            y: 0,
                            w: pageSize.width,
                            h: 5,
                        },

                    ],
                }
            ];
        },*/
        /*
        header: function (currentPage, pageCount, pageSize) {
            return [
                {
                    canvas: [
                        {
                            type: "rect",
                            x: 0,
                            y: 10,
                            w: pageSize.width,
                            h: 3,
                        },
                    ],
                },
            ];
        },
        */
        content: [
            {
                layout: 'noBorders',
                table: {
                    widths: ['*', 'auto', '*'],
                    body: [
                        [{
                            image: await getBase64ImageFromURL(process.env.REACT_APP_PUBLIC_URL + "clinica/" + obj.profile.id_clinica + "/logo/" + sessionStorage.getItem('token')),
                            fit: [180, 90],
                            alignment: 'center'
                        },
                        {
                            layout: 'noBorders',
                            table: {
                                body: [
                                    [{ text: obj.profile.nombre, style: 'head', alignment: 'center' }],
                                    [{ text: 'NIT: : ' + obj.profile.nit, style: 'texthead', alignment: 'center' }],
                                    [{ text: obj.profile.direccion.direccion, style: 'texthead', alignment: 'center' }],
                                    [{ text: obj.profile.telefono1, style: 'texthead', alignment: 'center' }],
                                    [{ text: obj.profile.email, style: 'texthead', alignment: 'center' }],
                                ],
                                alignment: 'center',
                            },
                        },
                        {
                            width: "*",
                            columns: [
                                {
                                    text: [
                                        {
                                            text: obj.title,
                                            bold: true,
                                            width: "auto",
                                            alignment: "right",
                                            lineHeight: 1.2,
                                            fontSize: 15,
                                        },
                                        {
                                            text: "\n"
                                        },
                                        {
                                            text: 'Fecha Reportada:' + obj.fecha_reportada,
                                            width: "auto",
                                            alignment: "right",
                                            lineHeight: 1.2,
                                            fontSize: 7.5,
                                        },
                                        {
                                            text: "\n"
                                        },
                                        {
                                            text: 'Fecha Impresión:' + moment(new Date()).format('DD/MM/YYYY'),
                                            width: "auto",
                                            alignment: "right",
                                            lineHeight: 1.2,
                                            fontSize: 7.5,
                                        },
                                    ]

                                },
                            ],
                            alignment: 'center'
                        },],
                    ],
                },
            },
            {
                style: "tableExample",
                table: {
                    headerRows: 1,
                    widths: itemWidths,
                    //keepWithHeaderRows: 1,
                    body: itemBody,
                },
                layout: "exampleLayout",
                dontBreakRows: true,
            },
        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                margin: [0, 0, 0, 10],
            },
            subheader: {
                fontSize: 16,
                bold: true,
                margin: [0, 10, 0, 5],
            },
            tableExample: {
                margin: [0, 5, 0, 0],
                fontSize: itemBodyFontSize
            },
            tableHeader: {
                bold: true,
                fontSize: 9,
                color: "black",
            },
        },
        defaultStyle: {
            columnGap: 15,
        },
    };

    const pdfDocGenerator = pdfMake.createPdf(docDefinition);
    pdfDocGenerator.getDataUrl(function (outDoc) {
        document.getElementById('pdfV').src = outDoc;
    });
};

const getBase64ImageFromURL = (url) => {
    return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = () => {
            var canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;

            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            var dataURL = canvas.toDataURL("image/png");

            resolve(dataURL);
        };

        img.onerror = error => {
            reject(error);
        };

        img.src = url;
    });
}

export default OperationDiaryPDF;